export default "__VITE_ASSET__B3xl1XY$__"